export const RiskLevels = {
  1: 'Low',
  2: 'Medium',
  3: 'High',
  4: 'Not Available'
};

export const FacilityTypes = {
  MD: 'SLB Facility',
  BW: 'Customer Site',
  CRM: 'Customer Site'
};
